import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Bot, UserPlus, UserCheck, CalendarPlus, Wrench, BookOpen, CalendarClock, PhoneCall, type LucideIcon,
} from "lucide-react";

interface Action { key: string; label: string; icon: LucideIcon; to: string; }

const ACTIONS: Action[] = [
  { key: "test-receptionist", label: "Test receptionist", icon: Bot, to: "/app/receptionist" },
  { key: "add-contact", label: "Add contact", icon: UserPlus, to: "/app/leads" },
  { key: "add-lead", label: "Add lead", icon: UserCheck, to: "/app/leads" },
  { key: "add-appointment", label: "Add appointment", icon: CalendarPlus, to: "/app/appointments" },
  { key: "add-service", label: "Add service", icon: Wrench, to: "/app/services" },
  { key: "add-knowledge", label: "Add knowledge", icon: BookOpen, to: "/app/knowledge" },
  { key: "connect-calendar", label: "Connect calendar", icon: CalendarClock, to: "/app/integrations" },
  { key: "configure-phone", label: "Configure phone", icon: PhoneCall, to: "/app/integrations" },
];

export function QuickActions() {
  const navigate = useNavigate();
  return (
    <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-4" data-testid="quick-actions">
      {ACTIONS.map(({ key, label, icon: Icon, to }) => (
        <button
          key={key}
          onClick={() => navigate(to)}
          data-testid={`quick-action-${key}`}
          className="group flex flex-col items-start gap-2.5 rounded-xl border border-slate-200 bg-white p-4 text-left transition-all hover:border-blue-300 hover:shadow-sm"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-blue-50 text-blue-600 transition-colors group-hover:bg-blue-600 group-hover:text-white">
            <Icon className="h-[18px] w-[18px]" strokeWidth={2} />
          </span>
          <span className="text-sm font-medium text-slate-800">{label}</span>
        </button>
      ))}
    </div>
  );
}
